import { ChangeEvent } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { isEmpty } from 'lodash'

// Reducers
import {
  setContactHomebotStepAdvanceOneStep,
  setContactHomebotShowModal,
  setContactHomebotStep,
  selectContactHomebotStep,
  STEPS,
  STEPS_CONST,
  setContactHomebotEmail,
  selectContactHomebotEmail,
} from '../../../../../../../../store/slices/contactHomebot'

// Components
import Step from '../../../../../ModalStepsOutline'
import TextInput from '../../../../../../../shared/Input/TextInput'

// Styles
import styles from './Email.module.scss'

export const Email = () => {
  const dispatch = useDispatch()
  const email = useSelector(selectContactHomebotEmail)
  const currentStep = useSelector(selectContactHomebotStep)
  const stepIndex = STEPS_CONST.indexOf(currentStep)

  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch(setContactHomebotEmail(e.target.value))
  }

  const handleSubmit = () => {
    dispatch(setContactHomebotStepAdvanceOneStep())
  }

  return (
    <Step stepLabel='contact-homebot-email'>
      <Step.HeaderNavSection
        currentStep={currentStep}
        steps={STEPS}
        onCancel={() => dispatch(setContactHomebotShowModal(false))}
        onBack={() =>
          dispatch(setContactHomebotStep(STEPS_CONST[stepIndex - 1]))
        }
      />
      <Step.Title>
        <FormattedMessage
          id='ContactHomebotButton.email.step.title'
          defaultMessage="What's the best email to reach you?"
        />
      </Step.Title>
      <form onSubmit={handleSubmit} className={styles.form}>
        <Step.Body>
          <TextInput
            type='email'
            placeholder='email@example.com'
            value={email}
            onChange={handleEmailChange}
          />
        </Step.Body>
        <Step.FooterButton disableButton={isEmpty(email)}>
          <FormattedMessage
            id='ContactHomebotButton.next.step.button'
            defaultMessage='Next step'
          />
        </Step.FooterButton>
      </form>
    </Step>
  )
}
